module.exports = __webpack_public_path__ + "img/digital_alarm.463fb200.png";